import {
	CUSTOMER_LIST_START,
	CUSTOMER_LIST_SUCCESS,
	CUSTOMER_LIST_ERROR,
	CUSTOMER_DETAIL_START,
	CUSTOMER_DETAIL_SUCCESS,
	CUSTOMER_DETAIL_ERROR,
	CUSTOMER_BOOKING_LIST_START,
	CUSTOMER_UT_BOOKING_LIST_REQUEST,
	CUSTOMER_OT_BOOKING_LIST_REQUEST,
	CUSTOMER_CT_BOOKING_LIST_REQUEST,
	CUSTOMER_CNT_BOOKING_LIST_REQUEST,
	CUSTOMER_UT_BOOKING_LIST_SUCCESS,
	CUSTOMER_OT_BOOKING_LIST_SUCCESS,
	CUSTOMER_CT_BOOKING_LIST_SUCCESS,
	CUSTOMER_CNT_BOOKING_LIST_SUCCESS,
	CUSTOMER_BOOKING_LIST_ERROR,
	CLEAR_PREVIOUS_REDUCER,
} from "../Constants/CustomerConstant";

const initialState = {
	loading: false,
	loadingUpcoming: false,
	loadingOngoing: false,
	loadingCanceled: false,
	loadingCompleted: false,
	data: [],
	detailData: [],
	utData: [],
	otData: [],
	ctData: [],
	cntData: [],
};

export default function CustomerReducer(state = { ...initialState }, action) {
	switch (action.type) {
		case CUSTOMER_LIST_START:
			return {
				...state,
				loading: true,
			};
		case CUSTOMER_LIST_SUCCESS:
			return {
				...state,
				data: action.payload,
				loading: false,
			};
		case CUSTOMER_LIST_ERROR:
			return {
				...state,
				loading: false,
				message: action.error.message,
			};
		case CUSTOMER_DETAIL_START:
			return {
				...state,
				loading: true,
			};
		case CUSTOMER_DETAIL_SUCCESS:
			return {
				...state,
				detailData: action.payload,
				loading: false,
			};
		case CUSTOMER_DETAIL_ERROR:
			return {
				...state,
				loading: false,
				message: action.error.message,
			};
		case CUSTOMER_BOOKING_LIST_START:
			return {
				...state,
				loading: true,
			};
		case CUSTOMER_UT_BOOKING_LIST_REQUEST:
			console.log(action.payload);
			return {
				...state,
				utData: [],
				loadingUpcoming: true,
			};
		case CUSTOMER_OT_BOOKING_LIST_REQUEST:
			console.log(action.payload);
			return {
				...state,
				otData: [],
				loadingOngoing: true,
			};
		case CUSTOMER_CT_BOOKING_LIST_REQUEST:
			return {
				...state,
				ctData: [],
				loadingCompleted: true,
			};
		case CUSTOMER_CNT_BOOKING_LIST_REQUEST:
			return {
				...state,
				cntData: [],
				loadingCanceled: true,
			};
		case CUSTOMER_UT_BOOKING_LIST_SUCCESS:
			console.log(action.payload);
			return {
				...state,
				utData: action.payload,
				loading: false,
				loadingUpcoming: false,
			};
		case CUSTOMER_OT_BOOKING_LIST_SUCCESS:
			console.log(action.payload);
			return {
				...state,
				otData: action.payload,
				loading: false,
				loadingOngoing: false,
			};
		case CUSTOMER_CT_BOOKING_LIST_SUCCESS:
			return {
				...state,
				ctData: action.payload,
				loading: false,
				loadingCompleted: false,
			};
		case CUSTOMER_CNT_BOOKING_LIST_SUCCESS:
			return {
				...state,
				cntData: action.payload,
				loading: false,
				loadingCanceled: false,
			};
		case CUSTOMER_BOOKING_LIST_ERROR:
			return {
				...state,
				loading: false,
				loadingUpcoming: false,
				loadingOngoing: false,
				loadingCanceled: false,
				loadingCompleted: false,
				message: action.error.message,
			};
		case CLEAR_PREVIOUS_REDUCER:
			return {
				...state,
				data: [],
				loading: false,
				detailData: [],
				utData: [],
				otData: [],
				ctData: [],
				cntData: [],
			};
		default:
			return state;
	}
}
